import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=74af2908&scoped=true"
import script from "./Stock.vue?vue&type=script&lang=js"
export * from "./Stock.vue?vue&type=script&lang=js"
import style0 from "./Stock.vue?vue&type=style&index=0&id=74af2908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74af2908",
  null
  
)

export default component.exports